import posthog from 'posthog-js';

if (process.env.IS_PRODUCTION_APP === 'true') {
  posthog.init('phc_PoLx2XRjyrnkFx48Kt9pisWbBleKA68TDNL5SkSgQhH', {
    api_host: 'https://app.posthog.com',
  });
}

export default posthog;
